<template>
  <FoodArtworkLayout :head-title="headTitle">
    <template v-slot:imageSlot>
      <div class="box-custom-image1" ref="imageDom">
        <img class="image-food" ref="imgFood" :src="imgSrc ? imgSrc : image" alt="">
        <div class="content-top">
          <img class="logo" ref="imgLogo" src="@/assets/img/background/Frame-2946.png" alt="">
          <div class="box-detail1">
            <gen-right-icon-component
              :inputText1="storeText1"
              :inputText2="storeText2"
              :inputText3="branchText"
              :previewOptions="storeOptions1"
              :previewVertOffset="storeOptions1.previewVertOffset"
              :isIcon="true"
            />
            <div class="clear"></div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="box-detail1">
            <div class="box-text-detail bt-font-cont">
              <div class="main-text bt-text1">
                <gen-left-component :inputText="despText1" :previewOptions="despOptions1" :previewVertOffset="despOptions1.previewVertOffset" :textLeft="textLeft"></gen-left-component>
              </div>
              <div class="main-text bt-text2">
                <gen-left-component :inputText="despText2" :previewOptions="despOptions2" :previewVertOffset="previewVertOffset" :textLeft="textLeft"></gen-left-component>
              </div>
              <div class="sub-text">{{ $t('QUOTE_OF_IMAGE') }}</div>
            </div>
          </div>
          <div class="box-logo-qr">
            <img class="logo-bt" src="@/assets/img/icons/Frame-2952.png" alt=""/>
            <div class="box-qr">
              <p>{{ $t('ORDER_NOW') }}</p>
              <qrcode-vue className="box-qr-inside" :value="qrResult" :size="qrCodeSize" level="L" />
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div :class="['overlay fil', shadowImageClass]" ref="imgOverlay"></div>
      </div>
      <div class="box-custom-image1-mobile" ref="imageDom_m">
        <img class="image-food" ref="imgFood_m" :src="imgSrc ? imgSrc : image" alt="">
        <div class="content-top font-top-m">
          <img class="logo" ref="imgLogo_m" src="@/assets/img/background/Frame-2946.png" alt="">
          <div class="box-detail1">
            <gen-right-icon-component
              :inputText1="storeText1"
              :inputText2="storeText2"
              :inputText3="branchText"
              :previewOptions="storeOptions1m"
              :previewVertOffset="storeOptions1m.previewVertOffset"
              :isIcon="true"
            />
            <div class="clear"></div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="box-detail1">
            <div class="box-text-detail bt-font-cont-mobile">
              <div class="main-text bt-text1">
                <gen-left-component :inputText="despText1" :previewOptions="despOptions1m" :previewVertOffset="despOptions1m.previewVertOffset" :textLeft="textLeftm"></gen-left-component>
              </div>
              <div class="main-text bt-text2">
                <gen-left-component :inputText="despText2" :previewOptions="despOptions2m" :previewVertOffset="previewVertOffsetm" :textLeft="textLeftm"></gen-left-component>
              </div>
              <div class="sub-text">{{ $t('QUOTE_OF_IMAGE') }}</div>
            </div>
          </div>
          <div class="box-logo-qr">
            <img class="logo-bt" src="@/assets/img/icons/Frame-2952.png" alt=""/>
            <div class="box-qr">
              <p>{{ $t('ORDER_NOW') }}</p>
              <qrcode-vue className="box-qr-inside-m" ref="qr_custom" :value="qrResult" :size="qrCodeSizeM" level="L"></qrcode-vue>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div :class="['overlay fil', shadowImageClass]" ref="imgOverlay_m"></div>
      </div>
    </template>
    <template v-slot:formSlot>
      <div class="box-form">
        <input type="file" @change="onFileChanged" class="hidden-files" ref="addFile" />
        <button class="btn-color change-pic" @click="onUpload">{{ btn_upload_label }}</button>
        <div class="box-input-add">
          <div class="container-box-input">
            <div class="box-label">
              <label class="label-left">{{ $t('MERCHANT_NAME') }}</label>
              <label class="label-right">
                <span v-text="storeText1.length"></span>
                <span ref="maximum_store">{{ `/${ $t('MERCHANT_NAME_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('MERCHANT_NAME_LIMIT')"
                v-model="storeText1"
                :placeholder="$t('INSERT_MERCHANT_NAME')"
              />
            </div>
          </div>
          <div class="box-add" v-if="isShow">
            <div class="plus-icon" @click="add_store_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('ADD_LINE_LABEL') }}</p>
          </div>
        </div>
        <div class="box-input-add" v-if="storebox2">
          <div class="container-box-input">
            <div class="box-label" >
              <label class="label-left">{{ $t('MERCHANT_LINE_2_NAME') }}</label>
              <label class="label-right">
                <span v-text="storeText2.length"></span>
                <span ref="maximum_store">{{ `/${ $t('MERCHANT_NAME_LINE_2_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('MERCHANT_NAME_LINE_2_LIMIT')"
                v-model="storeText2"
                :placeholder="$t('INSERT_MERCHANT_NAME_LABEL')"
              />
            </div>
          </div>
          <div class="box-remove">
            <div class="remove-icon" @click="rm_store_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('REMOVE_LINE_LABEL') }}</p>
          </div>
        </div>
        <div class="box-label">
          <label class="label-left">{{ $t('BRANCH_NAME_OPTIONAL') }}</label>
          <label class="label-right">
            <span v-text="branchText.length"></span>
            <span ref="maximum_branch">{{ `/${ $t('BRANCH_NAME_LIMIT') }` }}</span>
          </label>
        </div>
        <div class="border-linear">
          <input
            type="text"
            :maxlength="$t('BRANCH_NAME_LIMIT')"
            v-model="branchText"
            :placeholder="$t('INSERT_BRANCH_NAME_LABEL')"
          />
        </div>
        <div class="box-input-add">
          <div class="container-box-input">
            <div class="box-label">
              <label class="label-left">{{ $t('INTRODUCE_MERCHANT_LABEL') }}</label>
              <label class="label-right">
                <span v-text="despText1.length"></span>
                <span ref="maximum_info1">{{ `/${ $t('INTRODUCE_MERCHANT_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('INTRODUCE_MERCHANT_LIMIT')"
                v-model="despText1"
                :placeholder="$t('INSERT_INTRODUCE_LABEL')"
              />
            </div>
          </div>
          <div class="box-add" v-if="isShow2">
            <div class="plus-icon" @click="add_info_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('ADD_LINE_LABEL') }}</p>
          </div>
        </div>
        <div class="box-input-add" v-if="infobox2">
          <div class="container-box-input">
            <div class="box-label" >
              <label class="label-left">{{ $t('INTRODUCE_MERCHANT_LINE_2_LABEL') }}</label>
              <label class="label-right">
                <span v-text="despText2.length"></span>
                <span ref="maximum_info2">{{ `/${ $t('INTRODUCE_MERCHANT_LINE_2_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('INTRODUCE_MERCHANT_LINE_2_LIMIT')"
                v-model="despText2"
                :placeholder="$t('INSERT_INTRODUCE_LABEL')"
              />
            </div>
          </div>
          <div class="box-remove">
            <div class="remove-icon" @click="rm_info_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('REMOVE_LINE_LABEL') }}</p>
          </div>
        </div>
        <div class="box-label">
          <label class="label-full">
            {{ $t('INSERT_MERCHANT_CODE_LABEL') }}
          </label>
        </div>
        <div class="border-linear qr-code-input">
          <input
            type="text"
            v-model="qrcode_text"
            onkeypress='() => event.charCode >= 48 && event.charCode <= 57'
            :placeholder="$t('INSERT_MERCHANT_CODE_LABEL')"
          />
          <img
            class="icon-info"
            id="icon-info"
            src="@/assets/img/icons/dshop.png"
            alt=""
            @click="toggleIntroducePopup"
          />
        </div>
        <div class="back" id="open_update" @click="toggleBackPopup">
          <div><p>{{ $t('BACK_LABEL') }}</p></div>
        </div>
        <button class="btn-color save-pic" ref="save_pic" @click="toImage">{{ $t('SAVE_IMAGE_LABEL') }}</button>
        <div :class="['popup-saved', 'animatedFadeInUp', 'animated', savedPopupClass]" id="popup-saved">
          <p>{{ $t('SAVE_IMAGE_ALREADY_LABEL') }}</p>
          <img src="@/assets/img/icons/akar-icons_circle-check.png" alt=""/>
        </div>
        <div :class="['popup-back', backPopupClass]">
          <BackPopup :toggleBackPopup="toggleBackPopup" />
        </div>
        <div :class="['popup-info-pass', introducePopupClass]">
          <InfoPopup :toggleIntroducePopup="toggleIntroducePopup" />
        </div>
      </div>
    </template>
  </FoodArtworkLayout>
</template>

<script>
import FoodArtworkLayout from '@/layouts/FoodArtworkLayout.vue';
import bgEmpty from '@/assets/img/background/BG_empty.png';
import generateTextLeft from '@/components/GenerateText/GenerateTextLeft.vue';
import generateTextRightIcon from '@/components/GenerateText/GenerateTextRightIcon.vue';
import QrcodeVue from 'qrcode.vue';
import {
  blankMerchantUrl, merchantUrl, qrCodeFoodSize, qrCodeFoodSizeM,
} from '@/config/enum';
import { generateImageAndDownload } from '@/utils';
import InfoPopup from '@/components/Popup/InfoPopup.vue';
import BackPopup from '@/components/Popup/BackPopup.vue';

export default {
  name: 'FoodRecommend',
  metaInfo: {
    title: 'Food Recommend',
  },
  props: {
    headTitle: {
      type: String,
      required: true,
    },
  },
  components: {
    QrcodeVue,
    FoodArtworkLayout,
    InfoPopup,
    BackPopup,
    genLeftComponent: generateTextLeft,
    genRightIconComponent: generateTextRightIcon,
  },
  data() {
    return {
      imgSrc: '',
      imgSrcName: 'RBH_shop.jpg',
      storeText1: '',
      storeText2: '',
      branchText: '',

      storeOptions1: {
        safeWidth: 700,
        previewHeight: 120,
        previewVertOffset: 0,
        originalFontSize: 90,
        fontSize: 20,
        mgLine2: 5,
        mgLine3: 10,
      },
      storeOptions1m: {
        safeWidth: 120,
        previewHeight: 20,
        previewVertOffset: 0,
        originalFontSize: 14,
        fontSize: 11,
        mgLine2: 0,
        mgLine3: 4,
      },

      despText1: '',
      despOptions1: {
        safeWidth: 900,
        previewHeight: 120,
        previewVertOffset: 0,
        originalFontSize: 90,
      },
      despOptions1m: {
        safeWidth: 150,
        previewHeight: 20,
        previewVertOffset: 0,
        originalFontSize: 15,
      },

      despText2: '',
      despOptions2: {
        safeWidth: 900,
        previewHeight: 120,
        previewVertOffset: 115,
        originalFontSize: 90,
      },
      despOptions2m: {
        safeWidth: 150,
        previewHeight: 20,
        previewVertOffset: 18,
        originalFontSize: 15,
      },

      textLeft: 12,
      textLeftm: 6,

      image: bgEmpty,
      btn_upload_label: this.$t('UPLOAD_IMAGE_LABEL'),

      qrcode_text: '',
      qrCodeSize: qrCodeFoodSize,
      qrCodeSizeM: qrCodeFoodSizeM,
      storebox2: false,
      infobox2: false,
      isShow: true,
      isShow2: true,
      isShowIntroducePopup: false,
      isShowSavedPopup: false,
      isShowBackPopup: false,
      isShowShadow: false,
    };
  },
  computed: {
    qrResult() {
      if (this.qrcode_text !== '') {
        return merchantUrl(this.qrcode_text);
      }
      return blankMerchantUrl;
    },
    previewVertOffset() {
      if (this.despText1 !== '') { return this.despOptions2.previewVertOffset; }
      return this.despOptions1.previewVertOffset;
    },
    previewVertOffsetm() {
      if (this.despText1 !== '') { return this.despOptions2m.previewVertOffset; }
      return this.despOptions1m.previewVertOffset;
    },
    backPopupClass() {
      return this.isShowBackPopup ? 'popup-show' : '';
    },
    savedPopupClass() {
      return this.isShowSavedPopup ? 'fadeInUp' : '';
    },
    introducePopupClass() {
      return this.isShowIntroducePopup ? 'popup-show' : '';
    },
    shadowImageClass() {
      return this.isShowShadow ? 'format-overlay-recommend' : '';
    },
  },
  methods: {
    toggleIntroducePopup() {
      this.isShowIntroducePopup = !this.isShowIntroducePopup;
    },
    toggleBackPopup() {
      this.isShowBackPopup = !this.isShowBackPopup;
    },
    onFileChanged(e) {
      this.btn_upload_label = this.$t('CHANGE_IMAGE_LABEL');
      this.isShowShadow = true;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // const image = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        const image = e.target && e.target.result ? e.target.result : '';
        if (typeof image === 'string') {
          this.imgSrc = image;
          this.imgSrcName = file.name;
        }
      };

      reader.readAsDataURL(file);
    },
    toImage() {
      if (window.innerWidth <= 767) {
        const imageNode = this.$refs.imageDom_m;
        this.generateImageAndDownload(imageNode, 400);
      } else {
        const imageNode = this.$refs.imageDom;
        this.generateImageAndDownload(imageNode, 1200);
      }
    },
    generateImageAndDownload(imageNode, size) {
      generateImageAndDownload(imageNode, size, this.imgSrcName, this.onSave);
    },
    onUpload() {
      this.$refs.addFile.click();
    },
    onSave() {
      this.isShowSavedPopup = true;
      setTimeout(() => {
        this.isShowSavedPopup = false;
      }, 3000);
    },
    add_store_row() {
      this.storebox2 = true;
      this.isShow = false;
    },
    rm_store_row() {
      this.storebox2 = false;
      this.storeText2 = '';
      this.isShow = true;
    },
    add_info_row() {
      this.infobox2 = true;
      this.isShow2 = false;
    },
    rm_info_row() {
      this.infobox2 = false;
      this.despText2 = '';
      this.isShow2 = true;
    },
  },
};
</script>

<style scoped>

</style>
